
<div class="modal-header" translate *ngIf="shared">Shared tags</div>
<div class="modal-header" translate *ngIf="!shared">Tags</div>
<div class="modal-body">
  <spinner [text]="&quot;Loading tags&quot;|translate" *ngIf="loading"></spinner>
  <entity-list *ngIf="!loading" trackByKey="id" [entities]="tags" [filterKeys]="['name']" [sortEntityPaths]="['name']" className="list-group list-group-light" [pageSize]="pagination.pageSize">
    <ng-template entityListEmpty>
      <empty-state icon="tags" [text]="'No tags created yet'|translate"></empty-state>
    </ng-template>
    <ng-template entityListItem let-tag="entity">
      <div class="list-group-item combi single w-100" data-test-qa="tagItem"><a class="list-group-main no-wrap d-flex" (click)="editTag(tag)" data-test-qa="editTag">
          <media-tag class="badge-lg selectable" [tag]="tag" style.max-width="80%"></media-tag></a>
        <button class="btn btn-link d-flex no-caret" (click)="selectColor(tag)" data-test-qa="tagColorDropdown">
          <div class="badge" [style.background-color]="tag.color">&nbsp;</div><span class="sr-only" translate>Select color</span>
        </button>
        <button class="btn btn-link reveal" (click)="deleteTag(tag)" data-test-qa="deleteTag"><i class="far fa-trash"><span class="sr-only" translate>Delete</span></i></button>
      </div>
    </ng-template>
  </entity-list>
  <add-object-form class="mt-3" (submitted)="createTag($event)" [placeholder]="'New tag'|translate" data-test-qa="newTag"></add-object-form>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-info mr-auto" (click)="showShared()" *ngIf="!shared"><span translate>Manage shared tags</span></button>
  <button class="btn btn-outline-secondary" (click)="close()" data-test-qa="closeButton"><span translate>Close</span></button>
</div>